UAExportUsersCtrl.$inject = ['users', 'domain', 'UserCSVHeaders', 'domainInfo', 'graph']

export function applySubgroupNamesToUsers(users, subgroups) {
  if (!Array.isArray(users)) {
    return users
  }

  const subgroupMap = {}
  if (Array.isArray(subgroups) && subgroups.length > 0) {
    for (const subgroup of subgroups) {
      if (subgroup?.uuid && typeof subgroup.name === 'string') {
        subgroupMap[subgroup.uuid] = subgroup.name.trim()
      }
    }
  }

  for (const user of users) {
    if (!user) {
      continue
    }
    const subgroupNames = []

    if (Array.isArray(user.subgroup_uuids) && user.subgroup_uuids.length > 0) {
      for (const subgroupUuid of user.subgroup_uuids) {
        if (!subgroupUuid) {
          continue
        }

        let name = subgroupMap[subgroupUuid]
        if (typeof name === 'string') {
          const trimmedName = name.trim()
          if (trimmedName) {
            subgroupNames.push(trimmedName)
          }
        }
      }
    }

    user.subgroup_names = subgroupNames
  }

  return users
}

export function extractSupergroupNames(domainInfo) {
  const domainInfoRecord = domainInfo?.domainInfoRecordUI?.domainInfoRecord

  if (!domainInfoRecord) {
    return []
  }

  const supergroupsOnDomain = Array.isArray(domainInfoRecord.supergroups) ? domainInfoRecord.supergroups : []
  const supergroupNames = []

  for (const supergroup of supergroupsOnDomain) {
    if (supergroup && typeof supergroup.name === 'string') {
      const trimmed = supergroup.name.trim()
      if (trimmed && !supergroupNames.includes(trimmed)) {
        supergroupNames.push(trimmed)
      }
    }
  }
  return supergroupNames
}

export default function UAExportUsersCtrl(users, domain, UserCSVHeaders, domainInfo, graph) {
  this.product = ''
  this.users = users
  this.domain = domain
  this.productOptions = ['toolkit', 'pathways']

  // create a map of user_uuid => user hash; underlying user hashes should
  // be the same as those in the users array so changes to the map values
  // should change the array values
  var usersMap = {}
  this.users.forEach(
    function(u, i) {
      usersMap[u.uuid] = this.users[i]
    }.bind(this)
  )

  this.users = this.users.sort((u1, u2) => {
    if (u1.name.toLowerCase() < u2.name.toLowerCase()) {
      return -1
    }
    if (u1.name.toLowerCase() > u2.name.toLowerCase()) {
      return 1
    }
    return 0
  })

  applySubgroupNamesToUsers(this.users, (domainInfo?.subgroupsUI?.subgroups) || [])

  const supergroupNames = extractSupergroupNames(domainInfo)
  if (supergroupNames.length > 0) {
    for (const user of this.users) {
      if (!user) {
        continue
      }
      user.supergroups = supergroupNames
    }
  } else {
    for (const user of this.users) {
      if (user) {
        user.supergroups = []
      }
    }
  }

  function setSchoolForUsers(school, schoolUsers, usersMap) {
    schoolUsers.forEach(function(sUser) {
      if (usersMap[sUser.uuid]) {
        if (!usersMap[sUser.uuid].schools) {
          usersMap[sUser.uuid].schools = []
        }
        usersMap[sUser.uuid].schools.push(school)
      }
    })
  }

  // need to populate the users with their school name
  // to do this we get the users for each school, rather than
  // get the schools for each user (fewer requests since there's
  // usually fewer schools than users)
  var schools = domainInfo.schoolsUI.schools
  this.fetchingSchools = true
  var _self = this
  schools.forEach(function(s, sIndex) {
    ;(function(sch) {
      graph.getSchoolUsers(s.uuid).then(function(sUsers) {
        setSchoolForUsers(sch, sUsers, usersMap)

        // check if we've finished going through all the schools
        if (sIndex === schools.length - 1) {
          _self.fetchingSchools = false
          console.log('Finished fetching schools')
          console.log(_self.users)
        }
      })
    })(s)
  })
}
